import {useMemo} from "react";
import {skipToken} from "@reduxjs/toolkit/query";
import {dispatchRequestsSelector, useGetUnauthorizedDispatchRequestsQuery} from "@ots-frontend/ots-data";
import {useApp} from "@ots-frontend/ots-ui";
import {useGetContainerStatusInsights} from "../components/hooks/useGetContainerStatusInsights";

/** What HubGo's header island counts, for the side layout's island and the top layout's status strip alike. */
export const useNavIslandCounts = () => {
  const {regionId, appCategory} = useApp();

  const selectDispatchRequests = useMemo(() => dispatchRequestsSelector(), []);
  const {unauthorizedDispatchRequestCount} = useGetUnauthorizedDispatchRequestsQuery(regionId ?? skipToken, {
    selectFromResult: (result) => ({
      unauthorizedDispatchRequestCount: selectDispatchRequests(result, {}).length
    })
  });

  const {availableLoads, groupBy: {potentialShutIns}} = useGetContainerStatusInsights({category: appCategory});

  return {
    unauthorizedDispatchRequestCount,
    availableLoads: availableLoads ?? 0,
    potentialShutInsCount: potentialShutIns.length,
  };
};
